const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/settings/inbox/ai/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { aiInboxSearchSchema } from "@circle-react/pages/UnifiedInbox/AiInbox/aiInboxSearchParamsSchema";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/settings/inbox/ai")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: aiInboxSearchSchema
});